import React from 'react';
import Layout from '../../components/Layout';
import { SettingsIcon } from 'lucide-react';
const Settings: React.FC = () => {
  return <Layout title="Profile & Settings" persona="University Coordinator" universityName="UAE Business School" data-id="element-6469">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-6470">
        <div className="text-center py-16" data-id="element-6471">
          <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-6472">
            <SettingsIcon className="w-8 h-8 text-gray-400" data-id="element-6473" />
          </div>
          <h3 className="text-gray-500 font-medium mb-2" data-id="element-6474">
            Settings content coming soon
          </h3>
          <p className="text-gray-400 text-sm max-w-md mx-auto" data-id="element-6475">
            This page will allow you to manage your profile and university
            settings.
          </p>
        </div>
      </div>
    </Layout>;
};
export default Settings;